export default __webpack_public_path__ + "static/56-e7f5e725ee3891232793bbcd6e1b1c03.png";